var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-heading",class:[
    ("ds-heading-" + (_vm.size || _vm.tag)),
    _vm.align && ("ds-heading-align-" + _vm.align),
    _vm.primary && "ds-heading-primary",
    _vm.soft && "ds-heading-soft",
    _vm.noMargin && "ds-heading-no-margin"
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }